import { all } from "redux-saga/effects";
import Auth from "./Auth";
import Lookup from "./Lookup";
import Notifications from "./Notifications";

export default function* rootSaga(getState) {
  yield all([Auth(), Lookup(), Notifications()]);
}
